export default __webpack_public_path__ + "static/media/design_icon.aa862306.svg";